import React, { useEffect, useState } from 'react';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import OverviewContent from '../pages/OverviewContent';
import PackagesContent from '../pages/PackagesContent';
import SubscriptionsContent from '../pages/SubscriptionsContent';
import PaymentsContent from '../pages/PaymentsContent';
import GatewaysContent from '../pages/GatewaysContent';
import SettingsContent from '../pages/SettingsContent';
import { useTabStore } from '../store/tabStore';
import UsersContent from '../pages/UsersContent';
import AnalyticsContent from '../pages/AnalyticsContent';
import ForexContent from '../pages/ForexContent';

interface DashboardLayoutProps {
    children: React.ReactNode;
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
    const [darkMode, setDarkMode] = useState(false);
    const activeTab = useTabStore((state) => state.activeTab);
    const setActiveTab = useTabStore((state) => state.setActiveTab);

    useEffect(() => {
        const saved = localStorage.getItem('darkMode');
        if (saved === 'true') setDarkMode(true);
    }, []);

    // Always enable dark mode on mount
    useEffect(() => {
        document.documentElement.classList.add('dark');
        document.documentElement.classList.remove('light');
    }, []);

    const tabMap = {
        overview: 'Overview',
        packages: 'Packages',
        subscriptions: 'Subscriptions',
        payments: 'Payments',
        gateways: 'Gateways',
        settings: 'Settings',
        users: 'Users'
    };

    const renderContent = () => {
        switch (activeTab) {
            case 'overview':
                return <OverviewContent />;
            case 'packages':
                return <PackagesContent />;
            case 'subscriptions':
                return <SubscriptionsContent />;
            case 'payments':
                return <PaymentsContent />;
            case 'gateways':
                return <GatewaysContent />;
            case 'settings':
                return <SettingsContent />;
            case 'users':
                return <UsersContent />;
            case 'analytics':
                return <AnalyticsContent />;
            case 'forex':
                return <ForexContent />;
            default:
                return <OverviewContent />;
        }
    };

    return (
        <div className="min-h-screen bg-background flex">
            <Sidebar
                activeTab={activeTab}
                onTabChange={(tab) => setActiveTab(tab.toLowerCase())}
            />

            <div className="flex-1 flex flex-col ml-64 min-w-0">
                <Header sideTab={tabMap[activeTab as keyof typeof tabMap]} />
                <main className="flex-1 overflow-y-auto px-6 bg-background">
                    {renderContent()}
                </main>
            </div>
        </div>
    );
};

export default DashboardLayout;
